import React, { useState } from "react";
import { Menu, Home, Image, MapPin, Info, LogIn, LogOut, User, Upload, Map as MapIcon } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const GlobalSidebar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { isLoggedIn, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Strona zdjęcia i mapa mają własne sterowanie (lista szczytów, mapa, losowanie), a menu w
  // lewym górnym rogu tylko zasłaniało zdjęcie / narzędzia listy.
  if (location.pathname.startsWith('/picture/') || location.pathname.startsWith('/place/') || location.pathname === '/map') return null;

  const handleLogout = () => {
    logout();
    setOpen(false);
    navigate('/');
  };

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          style={{
            position: "fixed",
            top: "16px",
            left: "48px",
            zIndex: 9999,
            background: "#fff",
            borderRadius: "50%",
            border: "1px solid #ddd",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            width: "44px",
            height: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Menu size={22} />
        </button>
      )}

      <div
        style={{
          position: "fixed",
          top: 0,
          left: open ? 0 : "-260px",
          width: "260px",
          height: "100vh",
          background: "#fff",
          boxShadow: "2px 0 8px rgba(0,0,0,0.15)",
          zIndex: 9998,
          transition: "left 0.25s ease",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "16px 12px",
        }}
      >
        <h3 style={{ marginBottom: "10px", padding: "0 4px" }}>Geo Gallery</h3>

        <Link to="/" onClick={() => setOpen(false)} style={linkStyle}>
          <Home size={18} /> <span>Strona główna</span>
        </Link>

        <Link to="/map" onClick={() => setOpen(false)} style={linkStyle}>
          <MapIcon size={18} /> <span>Mapa</span>
        </Link>

        <Link to="/best-peaks" onClick={() => setOpen(false)} style={linkStyle}>
          <MapPin size={18} /> <span>Najlepsze szczyty</span>
        </Link>

        <Link to="/about" onClick={() => setOpen(false)} style={linkStyle}>
          <Info size={18} /> <span>O aplikacji</span>
        </Link>

        <div style={{ marginTop: "auto", borderTop: "1px solid #eee", paddingTop: "12px" }}>
          {isLoggedIn ? (
            <>
              <Link to="/gallery" onClick={() => setOpen(false)} style={linkStyle}>
                <Image size={18} /> <span>Galeria zdjęć</span>
              </Link>
              <Link to="/upload" onClick={() => setOpen(false)} style={linkStyle}>
                <Upload size={18} /> <span>Dodaj zdjęcia</span>
              </Link>
              <div style={{ borderTop: "1px solid #f0f0f0", marginTop: "8px", paddingTop: "8px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "6px 10px", color: "#555", fontSize: "13px" }}>
                  <User size={16} />
                  <span>{user?.displayName ?? user?.email}</span>
                </div>
                <button onClick={handleLogout} style={buttonStyle}>
                  <LogOut size={18} /> <span>Wyloguj się</span>
                </button>
              </div>
            </>
          ) : (
            <Link to="/login" state={{ from: location }} onClick={() => setOpen(false)} style={linkStyle}>
              <LogIn size={18} /> <span>Zaloguj się</span>
            </Link>
          )}
        </div>
      </div>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            zIndex: 9997,
          }}
        />
      )}
    </>
  );
};

const linkStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "8px 10px",
  borderRadius: "8px",
  textDecoration: "none",
  color: "#333",
  transition: "background 0.2s ease",
};

const buttonStyle: React.CSSProperties = {
  ...linkStyle,
  background: "transparent",
  border: "none",
  cursor: "pointer",
  width: "100%",
  fontSize: "inherit",
};

export default GlobalSidebar;
